import signupImg from "../../assets/image/signup.jpg"
import Template from "../../components/Auth/Template"
import "./Login.css";
function Signup() {
  return (
    <div className="login-container">
       <Template
      title="Join E-Manager Today"
      description1="Simplify your event management process"
      description2="Create, organize, and succeed—all in one platform."
      image={signupImg}
      formType="signup"
    />
    </div>
   
  )
}

export default Signup
